var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500,947.8c-24.7,0-44.8-20-44.8-44.8c0-49.4-40.2-89.6-89.6-89.6H52.2c-24.7,0-44.8-20-44.8-44.8V96.9 c0-24.8,20.1-44.8,44.8-44.8h268.7c123.5,0,223.9,100.5,223.9,223.9v627C544.8,927.8,524.7,947.8,500,947.8z M96.9,723.9h268.7 c32.6,0,63.2,8.7,89.6,24.1V276.1c0-74.1-60.3-134.4-134.4-134.4H96.9V723.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500,947.8c-24.7,0-44.8-20-44.8-44.8v-627c0-123.5,100.5-223.9,223.9-223.9h268.7c24.7,0,44.8,20,44.8,44.8v671.8 c0,24.8-20.1,44.8-44.8,44.8H634.4c-49.4,0-89.6,40.2-89.6,89.6C544.8,927.8,524.7,947.8,500,947.8z M679.1,141.7 c-74.1,0-134.4,60.3-134.4,134.4V748c26.4-15.3,57-24.1,89.6-24.1h268.7V141.7H679.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingsBlack);
export default __webpack_public_path__ + "static/media/bookings-black.aa9aae6f11734340cdcca08c6372cd12.svg";
export { ForwardRef as ReactComponent };